exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#top-nav h1.support {\r\n    color: #fff;\r\n    font-size: 22px;\r\n    line-height: 48px;\r\n    margin: 3px;\r\n}\r\n\r\n.support-main {\r\n    width: 960px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.support-section {\r\n    background: #fff;\r\n}\r\n\r\n.supportimg img {\r\n    height: 450px;\r\n}\r\n\r\n.support-main p {\r\n    text-align: center;\r\n}\r\n\r\n\r\n/*.supportimg img{\r\n    max-width:100%;\r\n    display:inline-block; \r\n    float:left;\r\n    width: 30%;\r\n    margin:0 30px 25px 0px; \r\n}\r\n.supportimg img:last-child{\r\n    margin:0 0px 25px 0px; \r\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy/support/support.component.css
// module id = 1079
// module chunks = 0